import { styled } from '../../Styles/stitches.config'

export const Breadcrumb = styled('li', {
    variants: {
        last: {
            true: {
                fontWeight: 600,
                pointerEvents: 'none',
            },
        },
    },
})

export const StyledBreadcrumbs = styled('ol', {
    alignItems: 'center',
    display: 'inline-flex',
    flexWrap: 'wrap',
    columnGap: '$2',
    listStyle: 'none',
    m: 0,
    p: 0,
})
